import { useResetPasswordMutation } from "@/app/features/auth/authApiSlice";
import {
  Navigate,
  Link as ReactLink,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import useSnackbar from "@/hooks/use-snackbar";

function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const { snackbar, showSnackbar } = useSnackbar();

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "richardrozario.rr@gmail.com",
      password: "rich@1234",
      submit: null,
    },
    validationSchema: Yup.object({
      password: Yup.string().max(255).required("Password is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const { error } = await resetPassword({
          token,
          password: values.password,
        });

        if (error) {
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: error?.data?.message });
          helpers.setSubmitting(false);
          return;
        }

        showSnackbar({
          message: "Password reset successfully",
        });

        navigate("/login");
      } catch (err) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        flex: "1 1 auto",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {snackbar}
      <Box
        sx={{
          maxWidth: 550,
          px: 3,
          py: "100px",
          width: "100%",
        }}
      >
        <Stack spacing={1} sx={{ mb: 3 }}>
          <Typography variant="h4">Reset Password</Typography>
        </Stack>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Stack spacing={3}>
            <TextField
              error={!!(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              label="Password"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="password"
              value={formik.values.password}
            />
          </Stack>

          {formik.errors.submit && (
            <Typography color="error" sx={{ mt: 3 }} variant="body2">
              {formik.errors.submit}
            </Typography>
          )}
          <Button
            fullWidth
            size="large"
            sx={{ mt: 3 }}
            type="submit"
            variant="contained"
            disabled={isLoading}
          >
            Continue
          </Button>
        </form>
        <Button
          fullWidth
          size="large"
          sx={{ mt: 3 }}
          component={ReactLink}
          to="/forgot-password"
        >
          Forgot Password
        </Button>
      </Box>
    </Box>
  );
}

export default ResetPasswordPage;
